import { render, staticRenderFns } from "./StartTicket.vue?vue&type=template&id=dfc766e6&scoped=true&"
import script from "./StartTicket.vue?vue&type=script&lang=js&"
export * from "./StartTicket.vue?vue&type=script&lang=js&"
import style0 from "./StartTicket.vue?vue&type=style&index=0&id=dfc766e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc766e6",
  null
  
)

export default component.exports